// src/components/UserMenu.js
import React, { useState, useRef, useEffect } from 'react';
import { FaUser, FaSignOutAlt, FaCog, FaChevronDown, FaUserCircle, FaRocket } from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';

const UserMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { user, logout } = useAuth();
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    logout();
    setIsOpen(false);
  };

  if (!user) return null;

  return (
    <div className="relative" ref={dropdownRef}>
       <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 rounded-lg bg-white border border-gray-200 hover:border-primary transition-all duration-300 shadow-sm hover:shadow-md"
      >
        <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
          <FaUser className="text-white text-sm" />
        </div>
        {/* <span className="text-sm font-medium text-gray-700">
          {user.fullname || user.username}
        </span> */}
        <FaChevronDown className={`text-gray-500 text-xs transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} />
      </button>

       {isOpen && (
        <div className="absolute left-0 mt-2 w-64 bg-white rounded-xl shadow-2xl border border-gray-100 py-2 z-50">
           <div className="px-4 py-3 border-b border-gray-100">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center">
                <FaUserCircle className="text-white text-xl" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-gray-900 truncate">
                  {user.fullname || 'مستخدم'}
                </p>
                {/* <p className="text-xs text-gray-500 truncate">
                  {user}
                </p> */}
                {/* <p className="text-xs text-gray-400 mt-1">
                  منضم منذ {user.joinDate}
                </p> */}
              </div>
            </div>
          </div>

          <div className="py-2">
            <a
              href="/tests"
              className="flex items-center gap-3 w-full px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-200"
              onClick={() => setIsOpen(false)}
            >
              <FaRocket className="text-green-500" />
              <span>ابدأ المراجعة</span>
            </a>

            <a
              href="/profile"
              className="flex items-center gap-3 w-full px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-200"
              onClick={() => setIsOpen(false)}
            >
              <FaUser className="text-blue-500" />
              <span>الملف الشخصي</span>
            </a>

            {/* <a
              href="/settings"
              className="flex items-center gap-3 w-full px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-200"
              onClick={() => setIsOpen(false)}
            >
              <FaCog className="text-gray-500" />
              <span>الإعدادات</span>
            </a> */}

             <div className="my-2 border-t border-gray-100"></div>

             <button
              onClick={handleLogout}
              className="flex items-center gap-3 w-full px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 transition-colors duration-200"
            >
              <FaSignOutAlt className="text-red-500" />
              <span>تسجيل الخروج</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserMenu;